import { BrowserModule, Title } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { VideoplayerComponent } from './features/videoplayer/videoplayer.component';
import { UserAskQuestionComponent } from './features/user-ask-question/user-ask-question.component';
import { UserSeeQuestionComponent } from './features/user-see-question/user-see-question.component';
import { UserStrawpollComponent } from './features/user-strawpoll/user-strawpoll.component';
import { UserPollComponent } from './features/user-poll/user-poll.component';
import { CountUpDirective } from './shared/count-up.directive';
import { VodQuestionListComponent } from './features/vod-question-list/vod-question-list.component';
import { VodQuestionListItemComponent } from './features/vod-question-list-item/vod-question-list-item.component';
import { FormsModule } from '@angular/forms';
import { HomeComponent } from './pages/event-shell/home/home.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatExpansionModule } from '@angular/material/expansion';
import { TokenInterceptor } from './core/interceptors/token-interceptor';
import { LoginComponent } from './pages/event-shell/login/login.component';
import { LogService } from './shared/log.service';
import { NgChartsModule } from 'ng2-charts';
import { UserVoteQuestionListComponent } from './features/user-vote-question-list/user-vote-question-list.component';
import {
  UserVoteQuestionListItemComponent
} from './features/user-vote-question-list-item/user-vote-question-list-item.component';
import { ClickOutsideModule } from 'ng-click-outside';
import { DescriptionComponent } from './features/description/description.component';
import { SlidelistComponent } from './features/slidelist/slidelist.component';
import { SlidelistItemComponent } from './features/slidelist/slidelist-item/slidelist-item.component';
import { SlideImageComponent } from './features/slide-image/slide-image.component';
import { VideoTimeFormatterPipe } from './shared/video-time-formatter.pipe';
import { MatIcon } from '@angular/material/icon';
import { HeaderComponent } from './shared/components/header/header.component';
import { EventShellComponent } from './pages/event-shell/event-shell.component';
import { FooterComponent } from './shared/components/footer/footer.component';



@NgModule({ declarations: [
        AppComponent,
        EventShellComponent,
        VideoplayerComponent,
        UserAskQuestionComponent,
        UserSeeQuestionComponent,
        UserStrawpollComponent,
        UserPollComponent,
        CountUpDirective,
        VodQuestionListComponent,
        VodQuestionListItemComponent,
        HomeComponent,
        LoginComponent,
        UserVoteQuestionListComponent,
        UserVoteQuestionListItemComponent,
        DescriptionComponent,
        SlidelistComponent,
        SlidelistItemComponent,
        SlideImageComponent,
        HeaderComponent,
        FooterComponent,
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
    AppRoutingModule,
    FormsModule,
    NgxPaginationModule,
    BrowserAnimationsModule,
    MatExpansionModule,
    NgChartsModule,
    ClickOutsideModule, VideoTimeFormatterPipe, MatIcon], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        Title,
        LogService,
        VideoplayerComponent,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
}
